<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidade',
    componentOptions: {
        title: 'Rastreabilidade',
        actions: [
            [
                {
                    name: 'Rastreabilidade',
                    iconClass: 'lyra-icon lyra-marcador',
                    showView: false,
                    action: 'abrirRastreabilidade',
                    route: 'Rastreabilidade',
                    nameTranslationKey: 'mensagens.menuLateral.rastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirRastreabilidade() {
            if (this.$route.name !== 'Rastreabilidade') {
                this.$router.push({ name: 'Rastreabilidade' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
